export const permissions = {
    computed: {
        canAddClient() {
            return this.$root.permissions.includes("client.add");
        },
        canViewClientDetails() {
            return this.$root.permissions.includes("client.details.view");
        },
        canViewClientFunding() {
            return this.$root.permissions.includes("client.funding.view");
        },
        canEditClientFunding() {
            return this.$root.permissions.includes("client.funding.edit");
        },
        canViewClientCreditCard() {
            return this.$root.permissions.includes("client.credit_card.view");
        },
        canViewClientNotes() {
            return this.$root.permissions.includes("client.notes.view");
        },
        canEditClientEmr() {
            return this.$root.permissions.includes("client.emr.edit");
        },

        canViewStaffNotes() {
            return this.$root.permissions.includes("staff.notes.view");
        },
        canAddStaff() {
            return this.$root.permissions.includes("staff.add");
        },
        canEditStaff() {
            return this.$root.permissions.includes("staff.edit");
        },
        canViewPayroll() {
            return this.$root.permissions.includes("staff.payroll.view");
        },
        canEditPayroll() {
            return this.$root.permissions.includes("staff.payroll.edit");
        },
        canViewAllStaffDetails() {
            return this.$root.permissions.includes("staff.details.all");
        },
        canViewDirectStaffDetails() {
            return this.$root.permissions.includes("staff.details.direct");
        },
        canEditScheduleClient() {
            return this.$root.permissions.includes("calendar.client.edit");
        },
        canEditScheduleStaffDirect() {
            return this.$root.permissions.includes("calendar.direct.edit");
        },
        canEditScheduleStaffAll() {
            return this.$root.permissions.includes("calendar.all.edit");
        },
        canCompleteAppointmentsInThePast() {
            return this.$root.permissions.includes("calendar.client.complete_past_appointments");
        },
        canCompleteOwnAppointments() {
            return this.$root.permissions.includes("calendar.self.complete_appointments");
        },
        canCompleteAllAppointments() {
            return this.$root.permissions.includes("calendar.all.complete_appointments");
        },
        canCompleteDirectAppointments() {
            return this.$root.permissions.includes("calendar.direct.complete_appointments");
        },
        canViewAllStaff() {
            return this.$root.permissions.includes("calendar.staff.view");
        },
        canViewAllClients() {
            return this.$root.permissions.includes("calendar.client.view");
        },
        canEditCompletedAppointments() {
            return this.$root.permissions.includes("calendar.client.edit_completed_appointments");
        },
        canCreateOwnAppointment() {
            return this.$root.permissions.includes("calendar.self.create");
        },
        canEditOwnAppointment() {
            return this.$root.permissions.includes("calendar.self.edit");
        },
        canAddEditGoals() {
            return this.$root.permissions.includes("clinical.goals.add");
        },
        canViewGoalDetails() {
            return this.$root.permissions.includes("clinical.goals.view");
        },
        canUseTrackers() {
            return this.$root.permissions.includes("clinical.trackers.view");
        },
        canTrackManually() {
            return this.$root.permissions.includes("clinical.trackers.add");
        },
        canViewEditFundingSources() {
            return this.$root.permissions.includes("funding_sources.view_edit");
        },
        canViewExportReports() {
            return this.$root.permissions.includes("reports.view_export");
        },
        // Permissions related to the organization's goLOTUS subscription
        canSubmitClaim() {
            return ["professional_platinum"].includes(this.$root.organization.type);
        },
        // Control center permissions
        ccCanViewOrganization() {
            return this.$root.permissions.includes("ccenter.organization.view");
        },
        ccCanViewUserAccounts() {
            return this.$root.permissions.includes("ccenter.accounts.view");
        },
    },
};
